import { distanceUnits } from 'constant/distanceUnits'

export const getUnitSuffixText = (value: string | number, unit: string = distanceUnits.Ft) => `${value} (${unit})`
